<mat-card>
    <mat-card-header>
        <h1 mat-card-title class="mat-headline-1">Acceptable Use Policy</h1>
    </mat-card-header>
    <mat-card-content>
        <p>This Acceptable Use Policy (“AUP”) describes rules that apply to any party (“Customer”) using any products
            and services (“Services”) provided by Mutara Inc. or any of its affiliates (collectively, “Mutara”) and any
            user of any software application or service made available by Customer that interfaces with the Services
            (“End User”). The examples described in this AUP are not exhaustive. Customer is responsible for its End
            Users’ compliance with this AUP. If Customer or any End User violates this AUP, Mutara may suspend
            Customer’s use of the Services. This AUP may be updated by Mutara from time to time upon reasonable notice,
            which may be provided via Customer’s account, e-mail, or by posting an updated version of this AUP at <a
                href='/aup'>{{baseUrl}}</a>.</p>
        <h2>No Inappropriate Content or Users</h2>
        <p>Parties will not use the Services to transmit or store any content or communications (commercial or
            otherwise) that is illegal, harmful, unwanted, inappropriate, objectionable, confirmed to be criminal
            misinformation, or otherwise poses a threat to the public. This prohibition includes use of the Services by
            a hate group or content or communications that originate from a hate group or are exploitive, abusive, or
            hate speech.</p>
        <h2>Prohibited Activities</h2>
        <p>Parties will not use the Services to engage in or encourage any activity that is illegal, deceptive,
            harmful, violating others’ rights, or harmful to Mutara’s business operations or reputation, including:
        </p>
        <div class='indented'>
            <h3>Violations of Laws</h3>
            <p>Violating any applicable laws, regulations, or industry standards or guidance (collectively,
                “Applicable Laws”). This includes violating Applicable Laws requiring:</p>
            <p class='indented'>(a) consent be obtained prior to transmitting, recording, collecting, or monitoring data
                or
                communications<i> or </i></p>
            <p class='indented'>(b) compliance with opt-out requests for any data or communications.</p>
            <h3>Interference with the Services</h3>
            <p>Interfering with or otherwise negatively impacting any aspect of the Services or any
                third-party networks that are linked to the Services.</p>
            <h3>Reverse Engineering</h3>
            <p>Reverse engineering, copying, disassembling, or decompiling the Services.</p>
            <h3>Falsification of Identity or Origin</h3>
            <p>Creating a false identity or any attempt to mislead others as to the identity of the sender
                or the origin of any data or communications.</p>
        </div>
        <h2>No Service Integrity Violations</h2>
        <p>Parties will not violate the integrity of the Services, including:</p>
        <div class='indented'>
            <h3>Bypassing Service Limitations</h3>
            <p>Attempting to bypass, exploit, defeat, or disable limitations or restrictions placed on the
                Services.</p>
            <h3>Security Vulnerabilities</h3>
            <p>Finding security vulnerabilities to exploit the Services or attempting to bypass any security
                mechanism or filtering capabilities.</p>
            <h3>Disabling the Services</h3>
            <p>Any denial of service (DoS) attack on the Services or any other conduct that attempts to
                disrupt, disable, or overload the Services.</p>
            <h3>Harmful Code or Bots</h3>
            <p>Transmitting code, files, scripts, agents, or programs intended to do harm, including viruses
                or malware, or using automated means, such as bots, to gain access to or use the Services.</p>
            <h3>Unauthorized Access.</h3>
            <p>Attempting to gain unauthorized access to the Services.</p>
        </div>
    </mat-card-content>
</mat-card>